// src/services/yarnFabricService.js
import api from './api'; // ✅ use the axios wrapper with token

export async function fetchPendingYarnFabricPOs(companyId = null) {
  try {
    let url = process.env.REACT_APP_YF_PENDING_API;
    if (companyId) {
      url += `?CompanyID=${companyId}`;
    }

    const response = await api.get(`/api/yf-po-approval-pending`);
    return response.data;
  } catch (err) {
    console.error("Error fetching pending yarn/fabric POs:", err);
    return [];
  }
}